import { queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import OnBoarding from "@components/static/OnBoarding/OnBoarding"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

const OnBoardingPage = ({ options, query, seo }) => {
  return (
    <Layout options={options} fullscreen>
      <Seo global={seo} title="Onboarding" />
      <OnBoarding params={query} />
    </Layout>
  )
}

export async function getServerSideProps({ query }) {
  const { seo } = await request({ query: `{ ${queries.seo} }` })
  const options = await loadOptionsData()
  return {
    props: {
      options,
      query,
      seo,
    },
  }
}

export default OnBoardingPage
